import AudioEnableBanner from "components/AudioEnableBanner";
import socketService from "../../socket/newsocketService";

import React, { useState, useEffect, useRef } from "react";
import {
  AppBar,
  Toolbar,
  Select,
  MenuItem,
  Box,
  IconButton,
  Drawer,
  Typography,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useDispatch, useSelector } from "react-redux";
import { storeState } from "../../Redux/Slice/dataSlice";
import { getDatabase, ref, onValue, off } from "firebase/database";
import NotificationImage from "Utils/NotificationImage";
import { useNavigate } from "react-router-dom";
import soundFile from "../../Raw/ring.wav";
import { formatDate } from "Utils/helper";

const MainHeader = () => {
  const audioSiren = useRef(new Audio(soundFile));
  const accessKey = useSelector((state) => state.data.accessKey);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [items] = useState([
    { label: "All State", value: "All State" },
    { label: "Abuja", value: "Abuja" },
    { label: "Abia", value: "Abia" },
    { label: "Adamawa", value: "Adamawa" },
    { label: "Akwa Ibom", value: "Akwa Ibom" },
    { label: "Anambra", value: "Anambra" },
    { label: "Bauchi", value: "Bauchi" },
    { label: "Bayelsa", value: "Bayelsa" },
    { label: "Benue", value: "Benue" },
    { label: "Borno", value: "Borno" },
    { label: "Cross River", value: "Cross River" },
    { label: "Delta", value: "Delta" },
    { label: "Ebonyi", value: "Ebonyi" },
    { label: "Edo", value: "Edo" },
    { label: "Ekiti", value: "Ekiti" },
    { label: "Enugu", value: "Enugu" },
    { label: "Gombe", value: "Gombe" },
    { label: "Imo", value: "Imo" },
    { label: "Jigawa", value: "Jigawa" },
    { label: "Kaduna", value: "Kaduna" },
    { label: "Kano", value: "Kano" },
    { label: "Katsina", value: "Katsina" },
    { label: "Kebbi", value: "Kebbi" },
    { label: "Kogi", value: "Kogi" },
    { label: "Kwara", value: "Kwara" },
    { label: "Lagos", value: "Lagos" },
    { label: "Nasarawa", value: "Nasarawa" },
    { label: "Niger", value: "Niger" },
    { label: "Ogun", value: "Ogun" },
    { label: "Ondo", value: "Ondo" },
    { label: "Osun", value: "Osun" },
    { label: "Oyo", value: "Oyo" },
    { label: "Plateau", value: "Plateau" },
    { label: "Rivers", value: "Rivers" },
    { label: "Sokoto", value: "Sokoto" },
    { label: "Taraba", value: "Taraba" },
    { label: "Yobe", value: "Yobe" },
    { label: "Zamfara", value: "Zamfara" },
  ]);

  const [selectedValue, setSelectedValue] = useState("All State");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSocketConnected, setIsSocketConnected] = useState(Boolean(socketService.isConnected()));

  useEffect(() => {
    const onConnect = () => setIsSocketConnected(true);
    const onDisconnect = () => setIsSocketConnected(false);

    socketService.on("connect", onConnect);
    socketService.on("disconnect", onDisconnect);
    socketService.on("connect_error", onDisconnect);

    setIsSocketConnected(Boolean(socketService.isConnected()));

    return () => {
      socketService.off("connect", onConnect);
      socketService.off("disconnect", onDisconnect);
      socketService.off("connect_error", onDisconnect);
    };
  }, []);
  const [notifications, setNotifications] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [hasNewNotification, setHasNewNotification] = useState(false);
  const [prevNotificationCount, setPrevNotificationCount] = useState(0);

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
    dispatch(storeState(event.target.value));
  };

  const handleClick = () => {
    setIsDrawerOpen(false);
    navigate("/NotificationPage");
  };

  const toggleDrawer = (open) => () => {
    setIsDrawerOpen(open);
    if (open) {
      setHasNewNotification(false);
      try {
        audioSiren.current.pause();
        audioSiren.current.currentTime = 0;
      } catch (error) {
        // console.error("Error stopping audio:", error);
      }
    }
  };

  useEffect(() => {
    const db = getDatabase();
    const notifRef = ref(db, "/notification");
    const { superAdmin, state: userState } = JSON.parse(localStorage.getItem("user")) || {};

    const unsubscribe = onValue(notifRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();

        const allNotifs = Object.keys(data).map((key) => ({
          Title: data[key].title,
          Text: data[key].text,
          Time: data[key].currentTimeStamp || "-",
          State: data[key].state || "",
        }));

        const filtered = superAdmin
          ? allNotifs
          : allNotifs.filter((notif) => notif.State?.toLowerCase() === userState?.toLowerCase());
        if (filtered.length > prevNotificationCount && !isDrawerOpen) {
          setHasNewNotification(true);
          try {
            audioSiren.current.play().catch((err) => {
              //  console.warn("Audio play was blocked:", err);
            });
          } catch (error) {
            // console.error("Error playing audio:", error);
          }
        }

        setPrevNotificationCount(filtered.length);

        setNotifications(filtered.reverse().map((notif, idx) => ({ ...notif, Sr: idx + 1 })));
      } else {
        setNotifications([]);
      }
    });

    return () => {
      off(notifRef);
    };
  }, [isDrawerOpen, prevNotificationCount]);

  const visibleNotifications = showAll ? notifications : notifications.slice(0, 5);
  //console.log("visibleNotifications", visibleNotifications);

  return (
    <>
      <AppBar position="fixed" sx={{ backgroundColor: "#0077E5", zIndex: 10 }}>
        <Toolbar sx={{ padding: "0 20px" }}>
          <Box sx={{ display: "flex", width: "100%", alignItems: "center" }}>
            <Box sx={{ flexGrow: 1 }} />
            {accessKey && (
              <Box sx={{ flexGrow: 0 }}>
                <Select
                  value={selectedValue}
                  onChange={handleSelectChange}
                  displayEmpty
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    width: "300px",
                    padding: "10px",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                    fontSize: "1rem",
                    "& .MuiSelect-icon": {
                      right: "10px",
                    },
                  }}
                >
                  <MenuItem value="" disabled style={{ padding: "10px" }}>
                    Select State
                  </MenuItem>
                  {items.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            )}

            <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
              <AudioEnableBanner />
              <IconButton color="inherit" onClick={toggleDrawer(true)}>
                <NotificationsIcon sx={{ color: hasNewNotification ? "red" : "#ffffff" }} />
              </IconButton>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            width: {
              xs: "90vw",
              sm: 500,
            },
            maxWidth: "100%",
            height: "40vh",
            maxHeight: "100vh",
            marginTop: 10,
          },
        }}
      >
        <Box
          sx={{
            padding: 2,
            height: "100%",
            overflowY: "auto",
          }}
        >
          <Typography variant="h6">Notifications</Typography>

          {visibleNotifications.length === 0 ? (
            <Typography sx={{ mt: 2 }}>No new notifications.</Typography>
          ) : (
            visibleNotifications.map((notif, idx) => (
              <Box key={idx} sx={{ mt: 2, borderBottom: "1px solid #ccc", pb: 1 }}>
                <Typography variant="subtitle1" fontWeight="bold">
                  <NotificationImage title={notif?.Title} width={25} height={25} /> {notif?.Title}
                </Typography>
                <Typography variant="body2">{notif?.Text}</Typography>
                <Typography sx={{ fontSize: 12 }}>{formatDate(notif?.Time)}</Typography>
              </Box>
            ))
          )}

          <button className="btn btn-primary btn-sm ms-6 mt-3" onClick={handleClick}>
            Show All Notifications
          </button>
        </Box>
      </Drawer>
    </>
  );
};

export default MainHeader;
